import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../../services/api";
import "./staff.css";

export default function ArchivedStaff() {
  const school   = JSON.parse(localStorage.getItem("schoolAdmin"));
  const navigate = useNavigate();

  const [staff,   setStaff]   = useState([]);
  const [loading, setLoading] = useState(true);

  const loadArchived = async () => {
    try {
      setLoading(true);
      const res = await API.get("/school-admin/staff/archived/", {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      setStaff(res.data.staff || []);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  useEffect(() => { loadArchived(); }, []);

  const restore = async (id) => {
    try {
      await API.post(
        `/school-admin/staff/restore/${id}/`,
        {},
        { headers: { "X-SCHOOL-ID": school.school.id } },
      );
      loadArchived();
    } catch (err) { console.error(err); alert("Failed to restore staff"); }
  };

  return (
    <div className="st-page">

      {/* ══ HERO ══ */}
      <div className="st-hero">
        <div className="st-hero-left">
          <div className="st-hero-icon">📦</div>
          <div>
            <h2 className="st-hero-title">Archived Staff</h2>
            <p className="st-hero-sub">View and restore previously archived staff members</p>
          </div>
        </div>
        <div className="st-hero-right">
          <button className="st-btn-back" onClick={() => navigate("/school-admin/staff")}>
            ← Active Staff
          </button>
        </div>
      </div>

      {/* ══ TABLE ══ */}
      <div className="st-card">
        {loading ? (
          <div className="st-empty">
            <div className="st-empty-icon">⏳</div>
            <strong>Loading archived staff…</strong>
          </div>
        ) : staff.length === 0 ? (
          <div className="st-empty">
            <div className="st-empty-icon">📭</div>
            <strong>No archived staff</strong>
            <p>All staff members are currently active</p>
          </div>
        ) : (
          <table className="st-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Role</th>
                <th>Phone</th>
                <th>Relieving Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {staff.map(s => (
                <tr key={s.id}>
                  <td>
                    <div className="st-name">{s.name}</div>
                  </td>
                  <td>
                    <div className="st-role">{s.role || "—"}</div>
                  </td>
                  <td>{s.phone || "—"}</td>
                  <td>
                    <span style={{
                      background: "#fee2e2", color: "#991b1b",
                      padding: "3px 10px", borderRadius: "20px",
                      fontSize: "12px", fontWeight: 700,
                    }}>
                      {s.relieving_date || "—"}
                    </span>
                  </td>
                  <td>
                    <button className="st-btn-restore" onClick={() => restore(s.id)}>
                      ↩ Restore
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

    </div>
  );
}
